import restAPI from "../../../http-common";

const initialState = () => ({
	branding: {
		branding_name: "kitro",
		colors: {
			0: "#002732",
			1: "#6EB882",
			2: "#F0B250",
			3: "#005491",
			4: "#B15520",
			5: "#6E3B44",
			6: "#C0C0C0",
			7: "#E18842",
			8: "#A9C0C1",
			9: "#496063"
		},
		logo_home: "https://kitro-branding-logo.s3.eu-central-1.amazonaws.com/kitro_logo_home.svg",
		logo_login: "https://kitro-branding-logo.s3.eu-central-1.amazonaws.com/kitro_logo_login.svg",
		logo_pdf: "https://kitro-branding-logo.s3.eu-central-1.amazonaws.com/kitro_logo_pdf.svg",
		font_family: "Nunito sans",
		login_picture: "https://kitro-branding-login.s3.eu-central-1.amazonaws.com/kitro_login.png"
	}
});

export default {
	namespaced: true,

	state: initialState(),
	mutations: {_setBranding, },
	actions: {
		// mutations cannot be called in async functions, while actions can
		setBranding,
	},
	getters: {
		brandingName: state => state.branding.branding_name,
		colors: state => state.branding.colors,
		logoHome: state => state.branding.logo_home,
		logoLogin: state => state.branding.logo_login,
		logoPDF: state => state.branding.logo_pdf,
		loginPicture: state => state.branding.login_picture,
		fontFamily: state => state.branding.font_family,
		serviceTimesColors: () => [
			"#6B939E",
			"#D38E4F",
			"#798980",
			"#9B6346",
			"#58746E",
			"#AE9084",
			"#F9E5C5",
			"#F4C67C",
			"#8C594C",
		],
		sourceWasteColors: state => {
			const colors = state.branding.colors;
			return {
				production: colors[5],
				plate: colors[6],
				preparation: colors[7],
			};
		}
	}
};

function _setBranding(state, branding) {

	/*
	 * this is the reason we have the additional `.branding` layer in state - if we used
	 * just `state = {...state, ...branding}` the state does not register the change,
	 * as we are trying to plug in another object; updating its internals gets the change
	 * propagated properly, incl. the getters... and that's what matters.
	 * ... the other option would be to iterate `Object.keys()`, but who wants to see that?
	 */
	state.branding = {
		...state.branding,
		...branding
	};
}

/*
 * If the new branding is different than the current one, it fetches the branding data and
 * triggers _setBranding mutation.
 * It will set the color variables even if the branding is the same.
 */
async function setBranding({ commit, getters }, newBrandingName) {
	if (getters.brandingName !== newBrandingName) {
		const res = await restAPI({
			method: "get",
			url: `/branding?brand=${newBrandingName}`
		});
		commit("_setBranding", {
			branding_name: newBrandingName,
			...res.data
		});
	}

	setColorVariables(getters.colors);
}

function setColorVariables(colors) {
	for (const _i in colors)
		document.documentElement.style.setProperty(`--color${_i}`, colors[_i]);

}
